import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import Cookies from 'js-cookie';
let { cookies_language } = Cookies.get()
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: cookies_language || 'th',
    backend: {
      /* translation file path */
      // loadPath: '/locales/{{ns}}/{{lng}}.json'
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    fallbackLng: cookies_language || 'th',
    debug: false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    // ns: ['trans'],
    // defaultNS: 'trans',
    // ns: ['common', 'auth', 'dashboard', 'realtime'], // Multiple namespaces
    defaultNS: 'common',
    keySeparator: '.', //false
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true
    }
  })

export default i18n